import React from "react"
import PropTypes from "prop-types"
import CurrencyFormat from "common/nibble/CurrencyFormat"

const nf = new Intl.NumberFormat("es-MX")

export default function TableTotal({ totals }) {
  const { total, amount, iva, recurrencia_gasto } = totals

  return (
    <>
      <tr className="table-head">
        <td colSpan={3} className="f-bold text-right">
          Totales
        </td>
        <td className="f-bold  border-b-black text-right">
          <CurrencyFormat prefix="$" value={amount} />
        </td>
        <td className="f-bold  border-b-black text-right">
          <CurrencyFormat prefix="$" value={iva} />
        </td>
        <td className="f-bold  border-b-black text-right">
          <CurrencyFormat prefix="$" value={total} />
        </td>
        <td className="f-bold  border-b-black text-right">
          <CurrencyFormat prefix="$" value={recurrencia_gasto} />
        </td>
      </tr>
    </>
  )
}

TableTotal.propTypes = {
  totals: PropTypes.object,
}
